<div class="d-flex flex-column flex-fill">
    <div class="d-flex flex-row flex-fill">
        <div *ngIf="deliveries" [class]="showStackFlyout ? 'col-6' : 'col-12'" [ngStyle]="{ height: showAsDialog ? '600px' : '' }">
            <dx-data-grid
                #dataGrid
                [dataSource]="deliveries"
                class="h-100 grid-fill"
                keyExpr="id"
                [columnAutoWidth]="false"
                [wordWrapEnabled]="true"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onExporting)="onExporting($event)"
                (onCellDblClick)="rowDoubleClick($event)"
            >
                <dxi-column dataField="id" caption="Id" width="80"></dxi-column>
                <dxi-column dataField="stackCount" caption="Stack Count" width="100"></dxi-column>
                <dxi-column dataField="scheduled" caption="Delivery Scheduled" width="130"></dxi-column>
                <dxi-column dataField="stackCompleted" caption="Stack Completed" width="130"></dxi-column>
                <dxi-column dataField="completed" caption="Completed" width="100"></dxi-column>
                <dxi-column dataField="driver.name" caption="Driver" width="100"></dxi-column>
                <dxi-column dataField="truck.name" caption="Truck" width="100"></dxi-column>
                <dxi-column dataField="trailer.name" caption="Trailer" width="100"></dxi-column>
                <dxi-column dataField="transportPlate.name" caption="Plate" width="100"></dxi-column>
                <dxi-column dataField="dealerList" caption="Dealers" width="200"></dxi-column>
                <dxi-column dataField="vinList" caption="VINs" width="300"></dxi-column>

                <dxi-column width="100"></dxi-column>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="'deliveries-grid'"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        class="btn btn-sm btn-primary ms-2"
                        (click)="openStack(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || uow.hasChanges()"
                    >
                        Open
                    </button>
                    <button class="btn btn-sm btn-secondary ms-2" (click)="print()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Print Stack Detail</button>
                    <button class="btn btn-sm btn-success ms-2" (click)="complete()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Mark As Complete</button>
                    <button
                        class="btn btn-sm btn-danger ms-2"
                        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || dataGrid.instance.getSelectedRowsData()[0].completed"
                    >
                        Delete
                    </button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="deliveries" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}</strong
                        ></span
                    >
                </div>
            </dx-data-grid>
        </div>
        <app-delivery-flyout
            #deliveryFlyout
            [delivery]="openedDelivery"
            [hidden]="!showStackFlyout"
            [readOnly]="isFlyoutReadOnly"
            (onCloseClick)="closeStack()"
            class="col-sm-6 d-flex flex-fill"
        ></app-delivery-flyout>
    </div>
</div>
